module.exports = __webpack_public_path__ + "img/88.40823de6.png";